import { get } from 'lodash'
import styled, { css } from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledAdaptiveCard = styled.div`
  padding: ${({ theme }) => get(theme, 'spacing.padding', 0)}px
    ${({ theme }: any) => get(theme, 'spacing.padding', 0)}px
    ${({ theme, hasActions }: any) => (hasActions ? 0 : get(theme, 'spacing.padding', 0))}px
    ${({ theme }: any) => get(theme, 'spacing.padding', 0)}px;
  background-color: ${({ theme }: any) => themeUtilities.getColor(theme, 'default', 'background')};
  border-radius: ${({ theme }: any) => get(theme, 'adaptiveCard.borderTopRadius', 4)}px
    ${({ theme }: any) => get(theme, 'adaptiveCard.borderTopRadius', 4)}px 4px 4px;
  border-top: 5px solid
    ${({ theme, priority }: any) =>
      themeUtilities.getRgbaColor(theme, get(theme, `priority.${priority}.color`, 'light'))};
  border-right: 1px solid
    ${({ theme, selected, priority }: any) =>
      selected ? themeUtilities.getRgbaColor(theme, get(theme, `priority.${priority}.color`)) : 'transparent'};
  border-bottom: 1px solid
    ${({ theme, selected, priority }: any) =>
      selected ? themeUtilities.getRgbaColor(theme, get(theme, `priority.${priority}.color`)) : 'transparent'};
  border-left: 1px solid
    ${({ theme, selected, priority }: any) =>
      selected ? themeUtilities.getRgbaColor(theme, get(theme, `priority.${priority}.color`)) : 'transparent'};
  margin: 0 auto 1rem;
  position: relative;
  box-shadow:
    rgb(0 0 0 / 20%) 0 3px 1px -2px,
    rgb(0 0 0 / 14%) 0 2px 2px 0,
    rgb(0 0 0 / 12%) 0 1px 5px 0;
  cursor: ${({ hasSelectAction }: any) => (hasSelectAction ? 'pointer' : 'initial')};
  max-width: 400px;
  transition-property: border, height, right, opacity, box-shadow;
  transition-duration: 400ms, 200ms, 200ms, 100ms, 500ms;
  opacity: 1;

  .common-actions {
    display: none;
  }

  :hover {
    .common-actions {
      display: block;
    }
    ${({ theme, hasSelectAction }: any) => {
      const shadow = get(theme, 'adaptiveCard.shadow')
      if (hasSelectAction && shadow) {
        return css`
          box-shadow: ${shadow.offsetX}px ${shadow.offsetY + 4}px ${shadow.blur + 4}px ${shadow.spread}px
            ${themeUtilities.getRgbaColor(theme, 'adaptiveCard.shadow.color')};
        `
      }
    }};
  }
`

const StyledAdaptiveCardBody = styled.div`
  position: relative;
`

const StyledLoadingWrapper = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgb(100 100 100 / 30%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: ${(props: any) => props.theme.baseZ};
`

StyledAdaptiveCard.defaultProps = {
  // @ts-expect-error
  theme: {}
}

export default StyledAdaptiveCard
export { StyledAdaptiveCardBody, StyledLoadingWrapper }
